const state = () => ({
    messages: [],
    online: {}
})
  
// for(let x in state.messages) {
//     state.messages[x] = false
//   }

const getters = {
    getMessages: state => state.messages,
    getStatus: state => state.online,
}

 const mutations = {
    SOCKET_newMessage(state, message) {
        state.messages.push(message)
    },
    SOCKET_newStatus(state, online) {
        state.online = online;
    },
  }

export default {
    state,
    getters,
    mutations,
  }